






import { Component, Vue } from 'vue-property-decorator'
import api from '@/services/api'

@Component
export default class extends Vue {
    isAnon = false
    onTap() {
        this.$router.push('/claim')
    }
    created() {
        this.$emit('hide')
        api.jwtPayload.subscribe(payload => {
            this.isAnon = payload.isAnon
            console.log('payload', payload);
            this.emit();
        })
        this.$router.afterEach((to, from) => {
            if (to.path === '/claim') {
                this.emit()
            } else {
                this.emit()
            }
        })
    }
    emit() {
        console.log(this.$route.path)
        if (this.isAnon) {
            if (this.$route.path !== 'claim') {
                this.$emit('show')
            } else {
                this.$emit('hide')
            }
        } else {
            this.$emit('hide')
        }
    }
}
